import type { ComponentProps, ReactNode } from "react"
import FieldDescriptionOrError from "./FieldDescriptionOrError"
import { Field, FieldLabel } from "@/ui/components/ui/field"
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@/ui/components/ui/input-group"
import { cn } from "@/ui/lib/utils"

type Props = ComponentProps<typeof InputGroupInput> &
  Pick<ComponentProps<typeof Field>, "orientation"> & {
    label?: string
    inputClassName?: string
    icon?: ReactNode
    error?: string | null
    helperText?: string
  }

export default function InputField({
  label,
  inputClassName,
  icon,
  error,
  helperText,
  name,
  value,
  required,
  className,
  placeholder,
  orientation,
  ...props
}: Props) {
  return (
    <Field
      className={className}
      data-invalid={!!error}
      orientation={orientation}
    >
      {label && (
        <FieldLabel
          htmlFor={name}
          className={cn("text-nowrap", required && "after:content-['*']")}
        >
          {label}
        </FieldLabel>
      )}
      <InputGroup>
        <InputGroupInput
          id={name}
          name={name}
          value={value ?? ""}
          className={inputClassName}
          placeholder={
            required && placeholder ? `${placeholder} *` : placeholder
          }
          aria-invalid={!!error}
          {...props}
        />
        {!!icon && <InputGroupAddon align="inline-end">{icon}</InputGroupAddon>}
      </InputGroup>
      <FieldDescriptionOrError description={helperText} error={error} />
    </Field>
  )
}
